import { defineStore } from 'pinia'

interface Loader {
	loading: boolean
	loadingText?: string
}
export const useLoader = defineStore('loader', {
	state: (): Loader => ({
		loading: false,
		loadingText: ''
	}),
	getters: {
		Loading(state) {
			return state.loading
		},
		Text(state) {
			return state.loadingText
		}
	},
	actions: {
		start(arg?: string) {
			return new Promise(resolve => {
				this.$state.loading = true
				this.$state.loadingText = arg as string
				resolve(this.$state.loading)
			})
		},
		stop() {
			return new Promise(resolve => {
				this.$state.loading = false
				this.$state.loadingText = ''
				resolve(this.$state.loading)
			})
		}
	}
})
